import React, { useEffect } from 'react';
import I18n from 'utils/I18n';
import { trackV2 } from 'utils/analytics';
import Overview from '../shared/Overview';
import Card from '../shared/Card';
import Inset from '../shared/Inset';
import Pricing from '../shared/Pricing';
import Footnote from '../shared/Footnote';
import { I18nPrefix } from '../../shared/constants';
import { useCheckoutContext } from '../../state/CheckoutContext';
import { subscriptionType } from '../../utils/checkoutUtils';

import styles from './SummaryStudents.scss';

const SummaryStudents = () => {
  const { checkoutEntityState } = useCheckoutContext();

  const { analyticsData, isTrial } = checkoutEntityState;

  useEffect(() => {
    const trackProps = {
      category: 'subscriptions',
      page: 'student_plan_checkout',
      properties: {
        ...analyticsData,
        subscription_type: subscriptionType(isTrial)
      }
    };
    trackV2({ ...trackProps, action: 'screen_enter' });
    return () => {
      trackV2({ ...trackProps, action: 'screen_exit' });
    };
  }, [analyticsData, isTrial]);

  return (
    <div className={styles.checkoutSummary}>
      <Card>
        <Inset>
          <Overview />
        </Inset>
        <Inset transparent={isTrial}>
          <Pricing
            isPrimary={true}
            label={I18n.t(
              `${I18nPrefix}.summary.students.billing.billed_today`
            )}
            showFootnote={!isTrial}
          />
        </Inset>
        {isTrial && (
          <Inset>
            <Pricing
              isPrimary={false}
              label={I18n.t(
                `${I18nPrefix}.summary.students.billing.billed_after_trial`
              )}
              showFootnote={true}
            />
          </Inset>
        )}
        <Inset>
          <Footnote />
        </Inset>
      </Card>
    </div>
  );
};

export default SummaryStudents;
